@if (personLogin) {
  <div>
    <table class="mainContentGrid">
      <tbody>
        <tr>
          <td class="thirdPageColumn">
            <table class="linkTable">
              <tr>
                <td class="tableCell centeredCell headerCell">Quick Links</td>
              </tr>
              @if (!hasRole('IECCredAnalyst') && !hasRole('IECReadOnly')
                && !hasRole('IECRSM') && !hasRole('LSBCS')) {
                <tr>
                  <span class="quickLink" (click)="showPartsDialog()">
                    Parts
                  </span>
                </tr>
              }
              <tr>
                <a routerLink="training" routerLinkActive="linkActive">Training</a>
              </tr>
              <tr>
                <a [routerLink]="['marketing']" [queryParams]="{documents: true}">Documentation</a>
              </tr>
              <tr>
                <a href="https://forms.office.com/pages/responsepage.aspx?id=x8vTmiIlSkqVmpsh0AX7aLc9NiD0uKxOsBsS85pKjxlUMU85R1dPNDkxOTVVSU9XV1FHS1ZTV1ZIUy4u&wdLOR=c25E06956-77CF-422A-95E0-50321405A935"
                  target="_blank">
                  Engineering Office Online Ratings Registration Form
                </a>
              </tr>
              <tr>
                <a [routerLink]="['marketing']" [queryParams]="{presentations: true}">Sales and Marketing Tools</a>
              </tr>
              @if (!hasRole('LSBCS')) {
                <tr>
                  <a href="https://wdf.iecokc.com" target="_blank">Wiring Diagrams</a>
                </tr>
              }
              <tr>
                <a href="https://expert.iecokc.com/index.html" target="_blank">Fan Coil Expert</a>
              </tr>
              <tr>
                <a href="https://info.iecokc.com/leadtimes" target="_blank">Current Lead Times</a>
              </tr>
              <tr>
                <a routerLink="myContacts" routerLinkActive="linkActive">My Contacts</a>
              </tr>
              @if (isInternalUser()) {
                <tr>
                  <a href="/quickUnitPricing">Quick Unit Pricing</a>
                </tr>
              }
            </table>
          </td>
          <td class="thirdPageColumn">
            <table class="displayTable">
              <thead>
                <tr>
                  <td class="tableCell centeredCell headerCell">Tasks</td>
                </tr>
              </thead>
              <table>
                <thead>
                  <tr>
                    <td class="tableCell centeredCell headerCell titleColumn">Title</td>
                    <td class="tableCell centeredCell headerCell entityIdColumn">Entity Id</td>
                    <td class="tableCell centeredCell headerCell entityRevisionColumn">Entity Revision</td>
                    <td class="tableCell centeredCell headerCell createDateColumn">Created</td>
                  </tr>
                </thead>
                @for (iecTask of iecTasks(); track iecTask) {
                  <tr>
                    @if (iecTask.targetUrl && iecTask.targetUrl.length > 0) {
                      <td class="tableCell"><a href="{{iecTask.targetUrl}}" target="_blank">{{ iecTask.name }}</a></td>
                    }
                    @if (!iecTask.targetUrl || iecTask.targetUrl.length == 0) {
                      <td class="tableCell">{{ iecTask.name }}</td>
                    }
                    <td class="tableCell">{{ iecTask.entityId }}</td>
                    <td class="tableCell">{{ iecTask.entityRevision }}</td>
                    <td class="tableCell">{{ iecTask.startTime | date: 'MM/dd/yyyy' }}</td>
                  </tr>
                }
                @if (!iecTasks() || iecTasks().length === 0) {
                  <tr>
                    <td colspan="4" class="tableCell">No records found</td>
                  </tr>
                }
              </table>
            </table>
          </td>
          <td class="thirdPageColumn">
            @if (marketingImage1()) {
              <img class="marketingImage" alt="" [src]="marketingImage1()"/>
            }
            @if (marketingImage2()) {
              <img class="marketingImage" alt="" [src]="marketingImage2()"/>
            }
            @for (newsAnnouncement of newsAnnouncements(); track newsAnnouncement) {
              <table class="displayTable">
                <tr>
                  <td class="tableCell centeredCell headerCell">{{ newsAnnouncement.headlineText }}</td>
                </tr>
                <tr>
                  <td class="tableCell" [innerHTML]="newsAnnouncement.details"></td>
                </tr>
              </table>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </div>
}
